export class OrganizationsTeachersItemModel {
	uid: number;
	name: string;
}
